/**
 * Fastcs2 public route families for prerender and sitemaps.
 *
 * /faq is the surface's own static page (faqRoutePolicy: 'none'), so the generators
 * do not append backend-driven FAQ child routes here — they would all redirect to /faq.
 */
export const seoRoutes: string[] = [
  /*[[START-PARSE]]*/
  '/',
  '/events/wallachia-nights',
  '/tos',
  '/faq',
  '/privacy-policy',
  /*[[END-PARSE]]*/
];
